import { OpcionValor } from "./opcion-valor.model";
import { Opcion } from "./opcion.model";
import { TablaDeEvaluacion } from "./tabla-de-evaluacion.model";


export enum Tipo {
    TEXTO_LIBRE = "Texto libre",
    ADJUNTO = "Adjunto",
    CHECKBOX = "Checkbox",
}

export class FormularioItem
{
    id: number;
    nombre: string;
    descripcion: string;
    valor: string;
    opcion: Opcion;
    level: number;
    expandable: boolean;
    editable: boolean;
    marcoNombre: string;
    enabled: boolean;
    sentencias: FormularioItem[];
    tipo: Tipo;
    adjuntos: string[];
    cumpleNoCumple: boolean;
    esRaiz: boolean;
    
    /**
     * Constructor
     *
     * @param formularioItem
     */
    constructor(formularioItem)
    {
        {
            this.id = formularioItem.id || null;
            this.nombre = formularioItem.nombre || '';
            this.descripcion = formularioItem.descripcion || '';
            this.marcoNombre = formularioItem.marcoNombre || "";
            this.enabled = formularioItem.enabled || true;
            this.sentencias= formularioItem.sentencias || [];
            this.tipo = formularioItem.tipo;
            this.adjuntos = formularioItem.adjuntos || [];
            this.cumpleNoCumple = formularioItem.cumpleNoCumple || false;
            this.level = formularioItem.level || 0;
            this.esRaiz = formularioItem.esRaiz || false;
        }

    }
    
}
